export const productData = [
  {
    id: 'crystal-serum-ultra',
    title: 'Crystal Serum Ultra',
    category: 'Professional Application only',
    categories: ['Auto', 'Ceramic Coating', 'Pintura'],
    description: 'Crystal Serum Ultra é nosso Revestimento Cerâmico mais avançado para pintura: brilho intenso, toque superliso e resistência máxima para manter o carro com aparência de novo por muito mais tempo.',
    cardDescription: 'Revestimento Cerâmico profissional de dupla camada (7H + 10H) que entrega brilho extremo, toque superliso e resistência superior. Proteção de até 9 anos.',
    image: 'crystal-serum-ultra.webp',
    videoUrl: 'https://youtu.be/FGfZnpPiZ8Q',
    quickOverview: [
      'Dupla camada 7H/10H',
      'Até 9 anos de proteção',
      'Aplicação por especialistas credenciados'
    ],
    mainSection: {
      heading: 'Por que escolher o Crystal Serum Ultra?',
      paragraphs: [
        'Crystal Serum Ultra é o ápice dos Revestimentos Cerâmicos para pintura da Gtechniq: entrega brilho intenso, toque superliso e uma defesa duradoura que mantém o carro com aparência de novo por muito mais tempo.',
        'Sua performance vem do sistema de dupla camada com nanopartículas de 7 nm e 20 nm e alta reticulação, que engrossa e reforça a camada superior do revestimento.',
        'A base flexível (7H) combinada com o topo extremamente duro (10H) oferece resistência muito superior a micro‑riscos, químicos de lavagem e até a dejetos de pássaros — superando revestimentos tradicionais de 9H.',
        'Também é estável em extremos de temperatura, de −40 °C a +250 °C.',
        'Pode ser usado sozinho como proteção de pintura e, para hidrofobicidade máxima, pode receber uma camada adicional de EXO ou C2.',
        'Aplicação exclusiva por Detailers Credenciados Gtechniq — encontre um especialista no nosso localizador.'
      ]
    },
    application: { heading: null, steps: [] },
    msds: { heading: null, links: [], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'Qual a diferença entre o Crystal Serum Ultra e o Crystal Serum Light?', answer: 'Ambos são Revestimentos Cerâmicos avançados da Gtechniq. O Ultra é um sistema profissional de dupla camada (7H/10H) com resistência e durabilidade máximas e aplicação exclusiva por especialistas credenciados. O Light é derivado do Ultra, com características similares, porém pensado para aplicação mais simples por entusiastas.' },
        { question: 'Posso aplicar EXO sobre o Ultra?', answer: 'Sim. EXO pode ser usado como top coat para elevar a hidrofobicidade e o brilho. Também é possível utilizar C2 como manutenção periódica.' },
        { question: 'Quanto tempo dura o Crystal Serum Ultra?', answer: 'Quando aplicado corretamente por um especialista credenciado e mantido de acordo com as recomendações, o Ultra pode proteger por até 9 anos.' },
        { question: 'O Ultra ajuda a reduzir micro‑riscos e é resistente a químicos?', answer: 'Sim. A combinação de base flexível (7H) e camada superior 10H oferece resistência muito superior a micro‑riscos e a químicos de lavagem, além de alta estabilidade térmica.' },
        { question: 'Quem pode aplicar o Ultra?', answer: 'Somente Detailers Credenciados Gtechniq. Encontre um profissional no nosso localizador.' },
        { question: 'O Ultra é indicado para carros novos e usados?', answer: 'Sim. Em veículos usados, recomenda‑se preparação com polimento técnico para nível máximo de correção e ancoragem.' },
        { question: 'É indicado para acabamentos foscos/acetinados?', answer: 'Não. Nem o Ultra nem o CSL são recomendados para acabamentos foscos ou acetinados. Para esses casos, utilize o C1, que preserva o visual sem adicionar brilho.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'crystal-serum-light',
    title: 'Crystal Serum Light',
    category: 'Revestimentos Cerâmicos',
    categories: ['Auto', 'Ceramic Coating', 'Pintura'],
    description: 'Crystal Serum Light é a versão para entusiastas derivada do nosso Crystal Serum Ultra. Entrega brilho intenso, proteção sólida e resistência química, com aplicação mais simples que o Ultra — e, se necessário, pode ser removido por polimento.',
    cardDescription: 'Revestimento Cerâmico derivado do Ultra, com características similares em brilho, proteção e resistência. Sua aplicação é mais fácil e possui durabilidade de até 5 anos.',
    image: 'crystal-serum-light.webp',
    videoUrl: 'https://youtu.be/Am3_CCDrFQ8',
    quickOverview: [
      'Brilho intenso e proteção sólida',
      'Aplicação mais simples',
      'Até 5 anos de durabilidade'
    ],
    mainSection: {
      heading: 'Por que usar o Gtechniq Crystal Serum Light?',
      paragraphs: [
        'Crystal Serum Light é derivado do Crystal Serum Ultra e compartilha suas qualidades de brilho, proteção e resistência — em uma fórmula pensada para o entusiasta que busca facilidade de aplicação.',
        'Entrega alto brilho, ajuda a minimizar micro‑riscos, repele sujeira e contaminantes, mantendo a pintura com aparência superior por muito mais tempo. Em caso de necessidade, pode ser removido por polimento.'        
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Para aplicar o Crystal Serum Light (CSL), mantenha o veículo em local interno por 12 horas após a aplicação. Não aplique sob luz solar direta.',
        'Aplique somente entre 5 °C e 25 °C.',
        'Agite bem e use luvas.',
        'Lave e descontamine a pintura cuidadosamente antes da aplicação. Se necessário, faça polimento (à máquina ou à mão) para remover imperfeições.',
        'Borrife Panel Wipe em um pano de microfibra MF1 da Gtechniq e limpe cada painel em pequenas seções.',
        'Embeba o aplicador com 3 medidas completas de CSL usando a pipeta e trabalhe o líquido no aplicador para saturá-lo de forma homogênea.',
        'Recoloque a tampa do frasco e deixe-o de lado — manter o frasco na mão acelera a cura prematura.',
        'Aplique em passadas sobrepostas em áreas de aproximadamente 60 cm × 60 cm.',
        'Remova o resíduo imediatamente com um pano MF1 — talvez seja necessário lustrar a mesma área algumas vezes, mas evite pressão excessiva. Recomendamos usar 2 panos e alterná-los para evitar cura do CSL no tecido.',
        'Inspecione a superfície com luz forte e difusa para verificar resíduos.',
        'Se o resíduo curar totalmente, repolir a área e reaplicar o CSL.',
        'Ao finalizar, mergulhe os panos MF1 em água e lave-os o quanto antes.',
        'Aguarde, no mínimo, 1 hora após aplicar o CSL para aplicar o EXO ou o C2.',
        'Armazene em local fresco e seco.',
        'Se aberto, usar em até 3 meses; fechado, em até 12 meses.',
        'Evite aplicação direta em frisos plásticos, borrachas e plásticos rígidos.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'Crystal Serum Light', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/CSL_EU_GB.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'O que diferencia o Crystal Serum Light do Ultra?', answer: 'O CSL é derivado do Ultra e compartilha características de brilho, proteção e resistência, porém foi formulado para aplicação mais simples por entusiastas.' },
        { question: 'Posso usar EXO como top coat sobre o CSL?', answer: 'Sim. EXO potencializa a repelência à água e o brilho do CSL, além de facilitar a manutenção.' },
        { question: 'O CSL pode ser removido?', answer: 'Se necessário, o CSL pode ser removido por polimento técnico, seguindo as boas práticas de preparação de superfície.' },
        { question: 'Qual a durabilidade típica do CSL?', answer: 'Até 5 anos, dependendo de preparo, aplicação e rotina de manutenção.' },
        { question: 'O CSL é indicado para acabamentos foscos/acetinados?', answer: 'Não. Nem o CSL nem o Ultra são recomendados para acabamentos foscos ou acetinados. Para esses casos, utilize o C1, que preserva o visual sem adicionar brilho.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'exo-ultra-durable-coating',
    title: 'EXOv5 Ultra Durable Hydrophobic Coating',
    category: 'Revestimentos Cerâmicos',
    categories: ['Auto', 'Ceramic Coating', 'Pintura'],
    description: 'Revestimento Cerâmico super hidrofóbico de alto brilho que repele água, sujeira, resiste a químicos de lavagem e deixa a pintura com aspecto vítreo. Camada única e manutenção muito mais fácil.',
    cardDescription: 'Revestimento Cerâmico hidrofóbico de alto brilho que repele água e sujeira. Também atua como top coat sobre C1, CSL ou Ultra. Uma única camada, 18–24 meses de proteção e manutenção muito mais fácil.',
    image: 'exov5.webp',
    videoUrl: 'https://youtu.be/pIDkgdjA3Ek',
    quickOverview: [
      'Camada única: 18–24 meses',
      'Top coat para C1/CSL/Ultra ou uso solo',
      'Alto brilho e repelência extrema'
    ],
    mainSection: {
      heading: 'Por que usar o Gtechniq EXOv5?',
      paragraphs: [
        'O EXOv5 combina tecnologia de siloxano composto para repelir água, sujeira e marcas d’água, com excelente resistência a químicos de lavagem e a micro‑riscos — resultando em um acabamento extremamente hidrofóbico, de alto brilho e aspecto vítreo.',
        'Forma uma camada homogênea mais durável e resistente ao sal de estrada e a produtos de lavagem, com aplicação simplificada: uma única camada e janela de remoção mais ampla para um acabamento perfeito.',
        'Pode ser usado sozinho ou como top coat sobre C1, CSL ou Ultra, elevando a repelência e o brilho da proteção.'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'O EXOv5 pode ser aplicado como revestimento independente ou como camada de cobertura para Gtechniq C1 Crystal Lacquer ou Gtechniq Crystal Serum Light (CSL) – recomendamos aplicar C1 ou CSL como base em pinturas escuras ou fáceis de marcar.',
        'Se for aplicar sobre C1, o EXOv5 deve ser aplicado no mínimo 4 horas e no máximo 12 horas após a conclusão da aplicação do C1.',
        'Se for aplicar sobre CSL, aguarde pelo menos 1 hora após a aplicação do CSL.',
        'Garanta que o veículo esteja fora da luz solar direta, acima de 5 °C, completamente seco e que permanecerá seco por pelo menos 12 horas após a aplicação.',
        'Faça a limpeza final com Gtechniq Panel Wipe e um pano MF1 ZeroR (aplique o Panel Wipe no pano, não diretamente no painel). Se estiver aplicando sobre C1/CSL recém‑aplicados, esta etapa não é necessária.',
        'Agite bem antes de usar e utilize luvas.',
        'Sature uniformemente o aplicador AP2 com uma boa quantidade de produto para umedecer a almofada por completo.',
        'Aplique em ambiente fresco, seco e longe da luz solar direta.',
        'Aplique uma camada fina e uniforme com o aplicador. Aguarde de 1 a 2 minutos e remova o resíduo com um pano MF1, seguido por um segundo MF1 para eliminar eventuais marcas. Apenas uma camada é necessária.',
        'Deixe o revestimento curar por, no mínimo, 12 horas antes de expor à umidade.',
        'Após aplicação, não lave o carro por pelo menos 7 dias.',
        'Armazene em local fresco e seco.',
        'Se aberto, usar em até 3 meses; se fechado, em até 12 meses.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'EXOv5', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2023/05/EXOv5_EU_GB-min.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'O que é revestimento cerâmico?', answer: 'Revestimento cerâmico é um líquido que se liga quimicamente à pintura do veículo, criando uma camada durável de proteção. O EXOv5 oferece desempenho hidrofóbico excepcional, aumentando o brilho e ajudando a repelir água, sujeira e contaminantes.' },
        { question: 'Vale a pena aplicar revestimento cerâmico?', answer: 'Sim — especialmente para quem busca proteção de longo prazo e manutenção mais fácil. O EXOv5 torna a lavagem do carro mais rápida e ajuda a prevenir problemas como manchas d’água, oxidação e manchas de sujeira.' },
        { question: 'Quanto tempo dura um revestimento cerâmico?', answer: 'A durabilidade varia de acordo com o produto e a rotina de cuidados. O EXOv5 costuma durar até 2 anos, mantendo a repelência à água e a resistência química com manutenção regular.' },
        { question: 'Como aplicar um revestimento cerâmico como o EXOv5?', answer: 'Aplique sobre pintura limpa e descontaminada, em ambiente fresco e seco. Com um aplicador, espalhe uma camada fina e uniforme e deixe curar. Em seguida, remova suavemente o resíduo com uma toalha de microfibra limpa. Sempre siga as instruções da Gtechniq para melhores resultados.' },
        { question: 'O revestimento cerâmico é seguro para todos os tipos de pintura?', answer: 'Sim — o EXOv5 é seguro para todos os acabamentos automotivos modernos, incluindo brilhoso, fosco e envelopamentos em vinil. Liga‑se em nível molecular, protegendo sem alterar a aparência de acabamentos especiais.' },
        { question: 'Posso aplicar o revestimento cerâmico sozinho?', answer: 'Sim — o EXOv5 foi projetado para ser acessível a entusiastas experientes, bem como a profissionais. Preparação adequada e paciência são essenciais, mas o processo de aplicação DIY é direto com as ferramentas e ambiente corretos.' },
        { question: 'Quanto custa aplicar revestimento cerâmico?', answer: 'Aplicações profissionais variam conforme o preparo necessário e o tamanho do veículo. Para quem opta pelo faça‑você‑mesmo, o EXOv5 oferece performance de alto nível com investimento menor — desde que a aplicação siga o procedimento correto.' },
        { question: 'Como remover um revestimento cerâmico?', answer: 'Com o tempo, os revestimentos cerâmicos se degradam naturalmente. Se precisar remover antes, o polimento técnico é o método mais eficaz. Avalie a superfície cuidadosamente antes de reaplicar o EXOv5 ou qualquer outro revestimento.' },
        { question: 'O que um revestimento hidrofóbico faz na prática?', answer: 'Revestimentos hidrofóbicos como o EXOv5 repelem água e contaminantes, facilitando a limpeza e ajudando a evitar manchas d’água, encardidos e acúmulo de sujeira. O acabamento mais liso também realça o brilho e a profundidade da cor.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'c1-crystal-lacquer',
    title: 'C1 Crystal Lacquer',
    category: 'Revestimentos Cerâmicos',
    categories: ['Auto', 'Ceramic Coating', 'Pintura'],
    description: 'Revestimento Cerâmico cristalino, muito fácil de aplicar — ideal para quem está começando ou busca proteção duradoura sem complicação.',
    cardDescription: 'Revestimento Cerâmico cristalino e fácil de aplicar que minimiza micro‑riscos e mantém o brilho. Ideal para acabamentos foscos/acetinados. Dura até 5 anos.',
    image: 'c1-crystal-lacquer.webp',
    videoUrl: 'https://youtu.be/5rwB3jlLMaU',
    quickOverview: [
      'Aplicação simples',
      'Minimiza micro‑riscos',
      'Ideal para fosco/acetinado — até 5 anos'
    ],
    mainSection: {
      heading: 'Por que usar o Gtechniq C1 Crystal Lacquer?',
      paragraphs: [
        'O C1 é simples de aplicar e entrega proteção duradoura sem complicação — perfeito para o primeiro Revestimento Cerâmico de quem está começando.',
        'Forma a superfície funcional da pintura e mantém o brilho com durabilidade de até 5 anos.',
        'Seu filme cristalino e rígido ajuda a minimizar marcas leves de lavagem em vernizes automotivos mais macios.',
        'Proporciona brilho intenso em acabamentos brilhosos, porém não altera o visual de pinturas foscas ou acetinadas, sendo também indicado para a proteção dessas.'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Aplicar apenas em temperaturas iguais ou superiores a 5 °C, em ambiente interno e fora da luz solar direta.',
        'Use as luvas fornecidas.',
        'Umedeça o aplicador com várias gotas do produto.',
        'Recoloque a tampa e deixe o frasco de lado. Segurar o frasco na mão durante a aplicação pode acelerar a cura.',
        'Aplique em passadas sobrepostas em áreas de aproximadamente 60 cm × 60 cm.',
        'Remova o resíduo imediatamente com um pano MF1 ZeroR.',
        'Talvez seja necessário polir a mesma área várias vezes; use pelo menos dois panos MF1, alternando‑os para evitar cura do produto no tecido.',
        'Troque o aplicador após 3 a 4 aplicações.',
        'Caso perca o tempo de remoção e o resíduo cure totalmente, repolir a área e reaplicar o C1.',
        'Após terminar, mergulhe as microfibras em água e lave‑as o quanto antes para evitar cristalização do produto.',
        'Mantenha o veículo em local interno por 12 horas antes de expor aos elementos.',
        'Se for aplicar EXO ou C2 sobre o C1, aguarde pelo menos 4 horas.',
        'Armazene em local fresco e seco.',
        'Se aberto, usar em até 3 meses; fechado, em até 12 meses.',
        'Evite aplicação direta em borrachas e vidro.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'C1', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/C1_EU_GB.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'O C1 adiciona brilho à pintura? Posso aplicar em pimturas foscas?', answer: 'O C1 forma um filme cristalino rígido que mantém e protege o acabamento. Em pinturas brilhosas o C1 cria um acabamento espelhado intenso. Ainda assim o C1 não modifica de maneira relevante o acabamento de pinturas foscas a acetinadas, sendo recomendado para estes tipos de pintura.' },
        { question: 'Posso aplicar EXO ou C2 sobre o C1?', answer: 'Sim. EXO como top coat eleva a hidrofobicidade e o brilho; C2 é excelente para manutenção rápida.' },
        { question: 'Qual a durabilidade do C1?', answer: 'Até 5 anos, dependendo de preparo, aplicação e rotina de manutenção.' },
        { question: 'O C1 é indicado para iniciantes?', answer: 'Sim. É um Revestimento Cerâmico fácil de aplicar e ideal para quem busca proteção duradoura sem complicação.' },
        { question: 'Funciona em todos os tipos de pinturas?', answer: 'Sim, inclusive em vernizes mais macios, pintura PU e Gel Coat, ajudando a minimizar marcas leves de lavagem quando aplicado corretamente e mantendo o visual de novo das superfícies tratadas por vários anos.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'c2-liquid-crystal',
    title: 'C2 Ceramic Sealant',
    category: 'Pintura',
    categories: ['Auto', 'Selantes Cerâmicos', 'Pintura'],
    description: 'Selante em spray com tecnologia de Revestimento Cerâmico (v4) que aumenta a repelência à sujeira, facilita a aplicação e estende a proteção — a versão mais eficaz e amigável até agora.',
    cardDescription: 'Selante em spray com proteção de Revestimento Cerâmico: brilho e repelência instantâneos. Aplicação em minutos e proteção que pode durar até 6 meses.',
    image: 'c2-ceramic-sealant.webp',
    videoUrl: 'https://youtu.be/mtwPx-S2yGo?si=ncm_8KwZVECwRFGL',
    quickOverview: ['Aplicação em minutos', 'Brilho e repelência instantâneos', 'Proteção por até 6 meses'],
    mainSection: {
      heading: 'Por que usar o Gtechniq C2 Ceramic Sealant?',
      paragraphs: [
        'C2 Ceramic Sealant v4 é o nosso selante em spray mais avançado: mais repelência, aplicação ainda mais fácil e proteção mais duradoura — ideal para manutenção rápida com resultado de alto brilho.',
        'Testes laboratoriais confirmam os ganhos: +4% no ângulo de contato da água (hidrofobicidade), +7% em repelência a óleo e +13% em energia livre de superfície, que melhora a autolimpeza.',
        'Mantém o veículo limpo por mais tempo ao repelir sujeira e fuligem e ainda protege contra raios UV e intempéries, preservando o acabamento com mínimo esforço.'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Agite bem antes de usar.',
        'Não aplique sob luz solar direta e use luvas.',
        'Pulverize sobre um pano MF1 limpo, passe em um painel de cada vez e lustre com um segundo MF1 limpo.',
        'Faça camadas para maior brilho e proteção — o produto é altamente concentrado; pouco rende muito.',
        'Pode ser usado como auxiliar de secagem: pulverize sobre a superfície ainda molhada, um painel por vez, e seque com a toalha MF4.',
        'Armazene em local fresco e seco.',
        'Após aberto, usar em até 12 meses.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'C2', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2025/04/C2v4_EU_GB-min.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'O que é um selante spray?', answer: 'Selante spray é um produto líquido aplicado à superfície do veículo para adicionar brilho, proteção e desempenho hidrofóbico. O Gtechniq C2 oferece proteção cerâmica poderosa em formato spray, ideal para manutenção rápida e brilho duradouro.' },
        { question: 'Selante spray realmente funciona?', answer: 'Sim — quando bem formulados, selantes spray como o Ceramic Sealant oferecem excelente proteção contra água, sujeira e raios UV. Ele se liga à superfície, melhora o brilho e facilita limpezas futuras ao repelir contaminantes.' },
        { question: 'Para que serve o C2 Ceramic Sealant?', answer: 'O selante é projetado para fornecer proteção hidrofóbica de alto brilho à pintura, rodas, plásticos e até vidro. Pode ser usado como selante independente ou como manutenção de veículos já revestidos com cerâmica.' },
        { question: 'Quanto tempo dura o C2 Ceramic Sealant?', answer: 'Normalmente dura até 6 meses por aplicação, variando conforme clima e frequência de lavagens. Reaplicações regulares prolongam o efeito.' },
        { question: 'O C2 é seguro para todas as superfícies?', answer: 'Sim — é seguro para verniz, vinil, plástico, rodas e vidro. Não deixa manchas nem resíduos e é pH neutro.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'c4-permanent-trim-restorer',
    title: 'C4 Permanent Trim Restorer',
    category: 'Plásticos',
    categories: ['Auto', 'Ceramic Coating', 'Plásticos'],
    description: 'Revestimento para plásticos externos que se liga quimicamente ao substrato, restaura o tom original e cria um filme ultrafino, flexível e durável com acabamento natural — sem brilho artificial.',
    cardDescription: 'Restaura plásticos ao aspecto de fábrica e sela a peça ligando‑se quimicamente à superfície. Acabamento natural, sem brilho artificial, por até 2 anos.',
    image: 'c4-trim-restorer.webp',
    videoUrl: 'https://youtu.be/oRx4ldKLrEk',
    quickOverview: ['Restaura aspecto de fábrica', 'Acabamento natural, sem brilho', 'Proteção por até 2 anos'],
    mainSection: {
      heading: 'Por que usar o Gtechniq C4 Permanent Trim Restorer?',
      paragraphs: [
        'O C4 liga‑se quimicamente ao plástico, tornando‑se uma extensão da peça que está protegendo.',
        'Sua troca molecular com o substrato garante uma proteção de longa duração, muito superior aos revitalizadores convencionais.',
        'Com filme finíssimo (~30 nm) e opticamente transparente, não cria brilho artificial: devolve o aspecto original até aos plásticos mais desbotados e ajuda a prevenir o esmaecimento de peças novas.'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Garanta quantidade suficiente de produto para todas as peças.',
        'Trabalhe em área bem ventilada, acima de 5 °C e sem luz solar direta. Use luvas.',
        'Certifique‑se de que a peça esteja livre de contaminantes — limpe com W5 puro, enxágue e seque. Se necessário, use uma escova de cerdas médias.',
        'Assegure que a superfície esteja totalmente seca e fria ao toque.',
        'Umedeça o aplicador AP1 com algumas gotas e espalhe o revestimento sobre o plástico.',
        'Remova o resíduo imediatamente com pano MF1. Em plásticos texturizados, cuide para cobrir todos os sulcos e remover todo o excesso.',
        'Deixe curar por 12 horas antes de expor aos elementos.',
        'Se aberto, usar em até 3 meses; fechado, em até 12 meses.',
        'Armazene em local fresco e seco.',
        'Evite aplicação direta em borrachas e vidro.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'C4', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/C4_EU_GB.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'Como restaurar plásticos externos desbotados?', answer: 'Limpe a superfície removendo sujeira e resíduos de produtos antigos. Com a peça limpa e seca, aplique o Gtechniq C4 usando o aplicador fornecido. A fórmula liga‑se quimicamente ao plástico, revive a cor e protege contra raios UV.' },
        { question: 'Quanto tempo dura o C4?', answer: 'Quando aplicado corretamente, pode durar até 24 meses, dependendo das condições de uso.' },
        { question: 'O C4 deixa o plástico brilhante?', answer: 'Não — ele devolve o acabamento acetinado, de fábrica, sem brilho excessivo.' },
        { question: 'O C4 é adequado para todos os tipos de acabamento plástico?', answer: 'Sim — o C4 foi desenvolvido para a maioria dos plásticos externos automotivos. Evite aplicar diretamente em borrachas e vidro e, em caso de dúvida, teste antes em uma área pequena e discreta.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'c5-wheel-armour',
    title: 'C5 Wheel Armour',
    category: 'Rodas & Acabamentos',
    categories: ['Auto', 'Ceramic Coating', 'Rodas'],
    description: 'Revestimento Cerâmico para rodas: repele pó de freio e contaminantes, suporta altas temperaturas e torna a limpeza muito mais fácil — preservando o visual por mais tempo.',
    cardDescription: 'Revestimento Cerâmico para rodas que resiste a até 600 °C, repele pó de freio e contaminantes. Limpeza muito mais fácil e proteção por até 2 anos.',
    image: 'c5-wheel-armor.webp',
    videoUrl: 'https://youtu.be/jOmancOi4tQ',
    quickOverview: ['Resiste a até 600 °C', 'Repele pó de freio — limpeza fácil', 'Proteção por até 2 anos'],
    mainSection: {
      heading: 'Por que usar o Gtechniq C5 Wheel Armour?',
      paragraphs: [
        'O C5 oferece proteção de alto desempenho para rodas, repelindo pó de freio e contaminantes para uma manutenção muito mais fácil.',
        'Sua camada ultrafina e a ligação química ao substrato garantem alta resistência a manchas e excelente durabilidade.',
        'Suporta até 600 °C, sendo adequado para rodas, pinças e ponteiras.'        
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Lave e descontamine as rodas com W5 e W6.',
        'Passe Panel Wipe em cada roda para máxima ancoragem. Cuidado com reparos spot que possam remover tinta.',
        'Agite bem e use luvas.',
        'Umedeça o aplicador AP1 com algumas gotas e espalhe em até metade da roda por vez.',
        'Remova o resíduo em 30–60 segundos com pano MF1.',
        'Repita em todas as rodas.',
        'Cure em local interno por 12 horas antes de expor ao tempo.',
        'Compatível com acabamentos brilhantes, acetinados e foscos.',
        'Armazene em local fresco e seco; utilizar frasco aberto em até 3 meses.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'C5', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/C5_EU_GB.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'O C5 é seguro para rodas foscas/satin?', answer: 'Sim. O C5 é compatível com acabamentos brilhantes, acetinados e foscos quando aplicado corretamente.' },
        { question: 'Ele resiste ao calor das pinças de freio?', answer: 'Sim. O revestimento mantém sua integridade até 600 °C, sendo indicado para rodas e pinças.' },
        { question: 'Posso aplicar em ponteiras de escape?', answer: 'Sim, o C5 é adequado para ponteiras de escape, ajudando a reduzir aderência de sujeira e facilitar a limpeza.' },
        { question: 'Quanto tempo dura o C5?', answer: 'Até 2 anos, variando com uso, temperatura e manutenção.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'halo',
    title: 'HALOv2 Flexible Film Coating',
    category: 'Revestimentos Cerâmicos',
    categories: ['Auto', 'Ceramic Coating', 'PPF & Vinil'],
    description: 'O HALO potencializa o desempenho de películas de proteção de pintura (PPF) e vinil. Forma um filme flexível ultradenso, quimicamente ligado, que se torna a superfície permanente da película — protegendo-a dos elementos do dia a dia. Compatível com fosco, brilhoso e acetinado.',
    cardDescription: 'Revestimento Cerâmico flexível para PPF e vinil que aumenta a vida útil, preserva o acabamento e facilita a limpeza. Compatível com fosco, brilhoso e acetinado. Protege por até 2 anos.',
    image: 'halo-version-2.webp',
    videoUrl: 'https://youtu.be/DkzcExwf4uc?si=GPHEjrXKfTKzJFZo',
    quickOverview: [
      'Aumenta a vida útil do PPF/vinil',
      'Facilita a limpeza',
      'Compatível com fosco, brilhoso e acetinado'
    ],
    mainSection: {
      heading: 'Por que usar o Gtechniq HALOv2 Flexible Film Coating?',
      paragraphs: [
        'O HALO foi desenvolvido para potencializar o desempenho de PPF e vinil, criando um filme flexível ultradenso, quimicamente ligado, que se torna a superfície permanente da película.',
        'Esse revestimento aumenta a vida útil, preserva o acabamento e facilita a limpeza do dia a dia graças à repelência a água e sujeira.',
        'Compatível com fosco, brilhoso e acetinado, mantém o visual original da película sem interferir na textura do acabamento.',
        'Testes laboratoriais e de campo comprovaram compatibilidade com todos os tipos de PPF e vinil, inclusive filmes autorregenerativos.'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Agite o frasco e use luvas.',
        'O veículo deve permanecer em local interno por pelo menos 12 horas após a aplicação. Iluminação adequada é essencial.',
        'Se aplicar em filme já instalado, lave e descontamine com W5 e W6.',
        'Com a superfície fria e seca, passe álcool isopropílico 30 % com pano MF1 para remover contaminantes.',
        'Aplique o HALO uniformemente no aplicador e espalhe em movimentos sobrepostos em áreas de ~60 cm × 60 cm.',
        'Após cada painel, remova o resíduo com MF1. Sempre remova além da área aplicada, trabalhando de fora para dentro.',
        'Faça inspeção final com luz difusa e MF1; apenas uma camada é necessária.',
        'Deixe curar por pelo menos 1 hora.',
        'Frasco fechado dura 12 meses; aberto, 3 meses.',
        'Evite aplicação direta em pintura e borrachas.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'HALO', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/HALOv2_EU_GB.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'O HALO é compatível com PPF autorregenerativo e vinil?', answer: 'Sim. Testes de laboratório e de campo confirmam compatibilidade com todos os tipos de PPF e vinil, incluindo filmes autorregenerativos.' },
        { question: 'Ele altera a textura ou o brilho da película?', answer: 'Não. O HALO preserva o acabamento original (fosco, brilhoso ou acetinado) e não altera a textura da película.' },
        { question: 'Quanto tempo dura o HALO?', answer: 'Até 2 anos, dependendo de uso, condições ambientais e manutenção.' },
        { question: 'Posso aplicar o HALO diretamente na pintura sem PPF/vinil?', answer: 'O HALO foi formulado especificamente para películas de PPF e vinil. Para pintura sem filme, utilize C1, CSL, EXO ou Ultra conforme o objetivo de proteção.' },
        { question: 'Quais os benefícios práticos no dia a dia?', answer: 'Aumenta a vida útil da película, facilita a limpeza e ajuda a reduzir manchas, mantendo o acabamento com aparência superior por mais tempo.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'i1-smart-fabric-ab',
    title: 'I1 Smart Fabric AB',
    category: 'Interior',
    categories: ['Auto', 'Interior', 'Tecido'],
    description: 'Nano revestimento para tecidos que protege contra líquidos à base de água sem bloquear a respirabilidade. Com proteção antibacteriana, oferece durabilidade comprovada — testes independentes indicam performance até 4× superior aos líderes de mercado.',
    cardDescription: 'Nano revestimento para tecidos que repele líquidos sem bloquear a respirabilidade. Proteção antibacteriana duradoura para bancos, carpetes e capotas.',
    image: 'i1v3-smart-fabric-ab.webp',
    videoUrl: 'https://youtu.be/cBqVPvYzLEg',
    quickOverview: ['Proteção por até 12 meses', 'Mantém a respirabilidade do tecido', 'Ação antibacteriana e antimofo'],
    mainSection: {
      heading: 'Por que usar o Gtechniq Smart Fabric AB?',
      paragraphs: [
        'Protege tecidos contra líquidos à base de água mantendo a respirabilidade natural do material.',
        'Com ação antimicrobiana, superfícies tratadas eliminam 99% das bactérias e ajudam a prevenir mofo e bolor — ideal para proteger você e sua família.',
        'Baseado em nanotecnologia: as nanopartículas envolvem cada fibra sem alterar a textura, permitindo a saída de ar e repelindo líquidos à base de água e óleo.',
        'Uso amplo: bancos, carpetes e até capotas conversíveis.'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Para uso interno, limpe primeiro com I2 TriClean.',
        'Para uso externo, limpe com W5 puro para sujeiras pesadas ou diluído 5:1 para sujidades leves.',
        'Garanta que o tecido esteja completamente seco (idealmente 48 h de secagem) e com umidade abaixo de 15 %.',
        'Agite bem e use luvas.',
        'Aplique acima de 5 °C em local bem ventilado e fora da luz solar direta.',
        'Pulverize a 15 cm de distância cobrindo homogeneamente até saturar o tecido.',
        'Evite sobreaplicação: após seco não é possível passar segunda demão, pois a primeira repelirá o produto.',
        'Se houver névoa em outras superfícies, limpe imediatamente com pano MF1.',
        'Deixe secar por 24 horas para eficácia total.',
        'Armazene em local fresco e seco e use em até 12 meses após aberto.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'I1AB', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/I1v3_EU_GB.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'Como limpar bancos de tecido do carro?', answer: 'Comece aspirando para remover sujeira solta. Para manchas, use um limpador de estofados como o Gtechniq Tri‑Clean. Com o tecido limpo e seco, aplique o I1 Smart Fabric AB para evitar futuros derramamentos, manchas e a proliferação de bactérias.' },
        { question: 'Como limpar o interior do carro de forma eficaz?', answer: 'Aspire carpetes, bancos e tapetes; depois use limpadores específicos para cada superfície (vidro, plástico, tecido). O I1 Smart Fabric AB é ideal para bancos de tecido, tapetes e revestimentos macios, oferecendo resistência duradoura à água e a manchas, além de proteção antibacteriana.' },
        { question: 'Posso usar um limpador multiuso no interior?', answer: 'O Gtechniq W5 All Purpose Cleaner, quando diluído corretamente (10:1), pode ser usado para limpar tecidos internos. Em seguida, finalize com o I1 Smart Fabric AB para formar um nano revestimento durável contra a sujeira do dia a dia e germes.' },
        { question: 'Qual é o melhor limpador para estofados do carro?', answer: 'Depende do material, mas para tecido, a dupla Gtechniq Tri‑Clean + I1 Smart Fabric AB oferece um cuidado completo — remove a sujeira existente e protege contra futuras manchas e microrganismos.' },
        { question: 'Qual a melhor rotina para limpeza interna?', answer: 'Uma boa rotina inclui aspiração, limpeza direcionada por material e finalização com proteção. O I1 Smart Fabric AB reforça essa rotina ao impedir que contaminantes penetrem nas fibras do tecido.' },
        { question: 'O I1 Smart Fabric AB é seguro para todos os tipos de tecido?', answer: 'Sim — o I1 é indicado para uma ampla gama de tecidos automotivos, incluindo bancos, carpetes e capotas conversíveis. Não altera a textura nem a respirabilidade do material.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'l1-leather-guard-ab',
    title: 'L1 Leather Guard AB',
    category: 'Interior',
    categories: ['Auto', 'Interior', 'Couro'],
    description: 'Revestimento para couro que preserva o acabamento natural, resiste à abrasão e à transferência de tinta, e protege contra raios UV — ideal para áreas de alto desgaste.',
    cardDescription: 'Proteção para couro com acabamento natural, resistente à abrasão e à transferência de tinta. Ação antibacteriana e defesa contra raios UV.',
    image: 'l1-leather-guard.webp',
    videoUrl: 'https://youtu.be/N1ncqpZ1hZ8',
    quickOverview: ['Acabamento natural, toque seco', 'Resiste à abrasão e UV', 'Previne transferência de tinta'],
    mainSection: {
      heading: 'Por que usar o Gtechniq L1 Leather Guard?',
      paragraphs: [
        'O L1 Leather Guard AB cria um acabamento natural resistente à abrasão que protege o couro contra raios UV, transferência de cor (tingimento) e descoloração.',
        'Com tecnologia antimicrobiana, superfícies tratadas eliminam 99,9% das bactérias.',
        'É a proteção ideal para bancos — especialmente apoios laterais (bolsters), volantes e áreas de alto desgaste. A proteção contra atrito é essencial nos reforços dos bancos e tubulações; a função anti‑mancha é especialmente relevante para couros claros, mais propensos a tingir com tecidos escuros como jeans índigo.',
        'Oferece de três a doze meses de durabilidade e utiliza uma fórmula atualizada, ambientalmente responsável, que supera a versão original em todos os aspectos.',
        'Quebra‑mitos:',
        'Muitos produtos para couro se promovem como “alimentos” para o couro, o que não é necessário. Os couros automotivos modernos usam lubrificantes sintéticos que não evaporam. Produtos que “alimentam” tendem a ficar na superfície, atraindo sujeira que age como abrasivo e encurta a vida útil do acabamento.'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Limpe o couro profundamente com I2 Tri‑Clean e deixe a superfície seca.',
        'Agite bem antes de usar e use luvas.',
        'Aplique em movimentos circulares usando o aplicador de espuma AP3, espalhando uma camada fina e uniforme.',
        'Remova o excesso com um pano de microfibra MF1 ZeroR.',
        'Para áreas de alto desgaste, reaplique uma segunda camada após 1 hora.',
        'Deixe secar por 1 hora antes do uso.',
        'Armazene em local fresco e seco.'
      ]
    },
    msds: { heading: 'MSDS', links: [{ label: 'L1AB', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/L1AB_EU_GB.pdf' }], description: null },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        { question: 'O L1 ajuda a evitar o tingimento do couro por jeans?', answer: 'Sim. O L1 cria uma camada protetora que reduz a transferência de cor de tecidos como jeans índigo, especialmente em couros claros.' },
        { question: 'Posso usar o L1 no volante e em áreas de alto desgaste?', answer: 'Sim. O L1 foi desenvolvido para resistir à abrasão e é ideal para áreas de alto contato como volante, apoios laterais (bolsters) e costuras.' },
        { question: 'O L1 altera o toque ou o visual do couro?', answer: 'Não. Ele preserva o acabamento natural e mantém toque seco e agradável quando aplicado corretamente.' },
        { question: 'Quanto tempo dura o L1 e quando reaplicar?', answer: 'De 3 a 12 meses, variando com uso e exposição. Em áreas de alto desgaste, recomenda‑se reaplicação mais frequente.' },
        { question: 'É seguro para couro perfurado ou pigmentado?', answer: 'Sim. O L1 é indicado para a maioria dos couros automotivos modernos, incluindo perfurados e pigmentados.' }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  }
  ,
  {
    id: 'g1-smart-glass',
    title: 'G1 ClearVision Smart Glass',
    category: 'Vidros',
    categories: ['Auto', 'Vidros'],
    description:
      'Revestimento hidrofóbico de longa duração para vidros automotivos. A água escorre com facilidade mesmo em baixas velocidades, melhorando a visibilidade sob chuva e reduzindo o uso do limpador.',
    cardDescription:
      'Revestimento hidrofóbico para vidros que se liga quimicamente ao vidro. Visibilidade superior na chuva, menos uso de limpadores. Durabilidade de até 2 anos.',
    image: 'g1-smart-glass.webp',
    videoUrl: 'https://youtu.be/hnJS02HOWC8',
    quickOverview: [
      'Hidrofobia intensa e visibilidade superior',
      'Dura até ~32.000 km',
      'Resiste à abrasão das palhetas'
    ],
    mainSection: {
      heading: 'Por que usar o Gtechniq G1 ClearVision Smart Glass?',
      paragraphs: [
        'Ao contrário dos revestimentos repelentes de chuva convencionais, que aderem ao vidro por ligações físicas relativamente fracas, o G1 cria uma ligação química com o substrato — garantindo uma durabilidade incomparável.',
        'O G1 ClearVision Smart Glass é extremamente durável: sua repelência à água melhora a visibilidade em dias de chuva, aumentando a segurança e reduzindo o cansaço visual. Ele também facilita a remoção de contaminantes do vidro, como resíduos de insetos, seiva de árvores e até gelo.',
        'O G1 funciona apenas em superfícies de vidro; portanto, não é indicado para lentes de faróis modernas, feitas de policarbonato. Para esses casos, utilize o G5 Water Repellent para vidro e acrílico (Perspex).',
        'Para aplicação somente no para‑brisa, escolha o frasco de 15 ml; para proteger todos os vidros do carro, opte pelo de 100 ml. O G1 acompanha o G2 Residue Remover (removedor de resíduos).'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Trabalhe em área bem ventilada, com temperatura a partir de 5 °C, e nunca sob sol direto. Use luvas.',
        'Limpe todo o vidro que será protegido com G6 Perfect Glass e um pano MF5 Power Glass Cloth.',
        'Para melhor performance, faça a preparação com G4 Nano Glass Polish — com máquina e boina média ou manualmente com pad de aplicação. Use pequena quantidade e trabalhe em movimentos circulares.',
        'Finalize limpando o vidro até ficar cristalino usando G6 e um MF5 ou MF1 ZeroR, repetindo quantas vezes forem necessárias para remover todo e qualquer resíduo.',
        'Agite bem o frasco do G1 antes de usar.',
        'Para para‑brisas: recomenda‑se 3 camadas de G1. Para vidros laterais e traseiro: 1 camada é suficiente.',
        'Aplique uma quantidade generosa de G1 no aplicador AP1 Lint‑Free e trabalhe em movimentos circulares cobrindo toda a área. Deixe curar por 5 minutos.',
        'Com um AP1 novo, aplique a mesma quantidade e recubra a primeira camada em movimentos lado‑a‑lado (horizontais). Deixe curar por mais 5 minutos.',
        'Aplique a terceira camada (mesma quantidade) com um AP1, agora em linhas retas verticais. Deixe curar por 15 minutos.',
        'Remova o resíduo curado com G2 Residue Remover: pingue G2 no aplicador restante, trabalhe pequenas áreas por vez e lustre imediatamente com um pano MF1.',
        'Finalize limpando as palhetas e o vidro com G6 Perfect Glass e um MF5.',
        'Recomendação: aplique uma camada fina de G1 nas palhetas sem remover o resíduo. Se as palhetas estiverem gastas, substitua‑as.',
        'Evite expor o carro aos elementos por pelo menos 12 horas.',
        'Armazene em local fresco e seco.',
        'Após aberto, utilize G1 e G2 em até 3 meses.'
      ]
    },
    msds: {
      heading: 'MSDS',
      links: [
        { label: 'G1', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/G1_EU_GB.pdf' }
      ],
      description: null
    },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        {
          question: 'Qual a diferença entre G1 e G5?',
          answer:
            'O G1 é um revestimento hidrofóbico de longa duração para vidro automotivo, com maior resistência e durabilidade. O G5 é de aplicação mais rápida e pode ser usado também em acrílico e policarbonato, porém com durabilidade mais curta.'
        },
        {
          question: 'Quanto tempo dura o G1?',
          answer:
            'A proteção pode durar até ~32.000 km ou 2 anos, no parabrisa este tempoo costuma ser mais curto, variando conforme uso e manutenção.'
        },
        {
          question: 'O G1 melhora a visibilidade na chuva?',
          answer:
            'Sim. A água se desprende do vidro com facilidade, o que ajuda a manter a visão clara e reduz o uso de limpadores, especialmente na estrada.'
        },
        {
          question: 'Posso aplicar o G1 em acrílico ou policarbonato?',
          answer:
            'Não é recomendado. Para superfícies de acrílico ou policarbonato, utilize o G5.'
        },
        {
          question: 'Preciso usar G2 e G4?',
          answer:
            'Para a melhor performance, sim. Use um polidor de vidro (ex.: G4) para preparar a superfície e um removedor dedicado (ex.: G2) para facilitar a remoção do resíduo e garantir acabamento cristalino e ancoragem ideal.'
        },
        {
          question: 'Os limpadores podem trepidar após a aplicação?',
          answer:
            'É possível ocorrer leve trepidação nas palhetas. Em 90% dos casos desaparece em até duas semanas. Limpe bem o para‑brisa e as palhetas com G6; aplicar uma leve camada de G1 nas palhetas (sem remoção) ajuda. Se as palhetas estiverem gastas, troque‑as.'
        },
        {
          question: 'Quantas camadas devo aplicar?',
          answer:
            'Em geral, 3 camadas no para‑brisa e 1 camada nos vidros laterais e traseiro. Respeite os tempos de cura entre camadas conforme as instruções.'
        }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  },
  {
    id: 'g5-water-repellent',
    title: 'G5 Water Repellent Coating',
    category: 'Vidros',
    categories: ['Auto', 'Vidros'],
    description:
      'Revestimento hidrofóbico de aplicação rápida para vidro, acrílico e policarbonato. Aumenta a segurança em dias de chuva, facilita a limpeza e dura até 4 meses.',
    cardDescription:
      'Revestimento hidrofóbico para vidro, acrílico e policarbonato. Aplicação simples, repelência imediata e até 4 meses de proteção — ideal para uso urbano.',
    image: 'g5-water-repellent.webp',
    videoUrl: 'https://youtu.be/tzm5mzTQ7So',
    quickOverview: ['A máxima repelência à água', 'Dura até 4 meses', 'Para vidro, acrílico e policarbonato'],
    mainSection: {
      heading: 'Por que usar o Gtechniq G5 Water Repellent Coating?',
      paragraphs: [
        'Para máxima repelência à água e à sujeira, aplique o G5 em todas as superfícies de vidro e também em acrílico e policarbonato.',
        'Altamente hidrofóbico, o G5 faz a água formar gotas e escorrer mesmo a baixas velocidades — aumentando a segurança e diminuindo a necessidade de acionar as palhetas.',
        'Os vidros tratados com G5 permanecem limpos por mais tempo, e contaminantes como insetos, dejetos de pássaros e gelo saem com muito mais facilidade.',
        'O G5 entrega repelência máxima, porém sua durabilidade é menor do que a do G1 ClearVision Smart Glass.'
      ]
    },
    application: {
      heading: 'Informações de Aplicação',
      steps: [
        'Use luvas e trabalhe em área ventilada.',
        'Limpe o vidro com G6 Perfect Glass.',
        'Ao trabalhar em vidro, faça o polimento com G4 Nanotech Glass Polish e faça uma limpeza final com G6 antes da aplicação.',
        'Não aplique sob luz solar direta.',
        'Aplique pequena quantidade de G5 em um AP1 Applicator ou pano MF1, em movimentos circulares cobrindo todo o vidro (ou a superfície de acrílico/policarbonato).',
        'Deixe o revestimento curar por 10–15 minutos em temperatura ambiente.',
        'Remova o resíduo com um pano MF5 Power Glass Cloth ou MF1.',
        'Evite contato com água por pelo menos 2 horas após a aplicação.',
        'Armazene em local fresco e seco.',
        'Use em até 12 meses após aberto.'
      ]
    },
    msds: {
      heading: 'MSDS',
      links: [
        { label: 'G5', url: 'https://www.gtechniq.co.uk/wp-content/uploads/2024/05/G5_EU_GB.pdf' }
      ],
      description: null
    },
    faqs: {
      heading: 'Dúvidas Frequentes',
      subheading: 'Precisa de ajuda?',
      items: [
        {
          question: 'Qual a diferença entre G5 e G1?',
          answer:
            'O G5 é de aplicação rápida, tem durabilidade de até 4 meses e pode ser usado também em superfícies de acrílico e policarbonato. O G1 é específico para vidro e oferece maior resistência e durabilidade de até ~32.000 km ou 2 anos.'
        },
        {
          question: 'Posso usar o G5 em viseiras e para-brisas de moto?',
          answer:
            'Sim, desde que a superfície seja de acrílico ou policarbonato compatível. Faça um teste em área discreta antes e evite aplicar em áreas internas que possam embaçar.'
        },
        {
          question: 'Quanto tempo dura o G5?',
          answer:
            'A proteção típica é de até 4 meses por aplicação, variando com clima e uso. Reaplique para manter a repelência ideal.'
        },
        {
          question: 'Quanto tempo devo esperar para molhar após aplicar o G5?',
          answer:
            'Evite contato com água por pelo menos 2 horas após a aplicação para não comprometer a cura inicial.'
        },
        {
          question: 'O G5 pode ser aplicado sobre o G1?',
          answer:
            'Normalmente não é necessário. O G1 já oferece longa duração. O G5 é indicado como solução rápida e para superfícies acrílicas onde o G1 não é recomendado.'
        }
      ]
    },
    shopUrl: 'https://gtechniq.com.br/loja',
    detailerLocatorUrl: '/encontre-um-profissional'
  }
];
